import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";
import {useTranslation} from "react-i18next";
import {RightSidebarFloatingPanel} from "../../../layout/rightSidebar/RightSidebarFloatingPanel";
import {RightSidebarPanelButton} from "../../../layout/rightSidebar/RightSidebarRail";
import ColumnConfiguratorPanel from "../components/ColumnConfiguratorPanel";
import {useServerTableContext} from "../ServerTableContext";

export function ServerTableRailColumns() {
    const {t} = useTranslation();
    const {table} = useServerTableContext();

    return (
        <RightSidebarPanelButton
            icon={<ViewColumnOutlinedIcon/>}
            label={t("Columns")}
            renderPanel={close => (
                <RightSidebarFloatingPanel sx={{overflow: "hidden"}}>
                    <ColumnConfiguratorPanel table={table} onClose={close}/>
                </RightSidebarFloatingPanel>
            )}
        />
    );
}
